import { useEffect, useState } from "react";
import { CompletedImg, CrossIcon } from "../../components/icons/Icon";
import styles from "./Invoice.module.css";
import Button from "../../components/updatedComponents/Dealers/Button";
import PDFUpload from "./PDFUpload";
import { handleFileData } from "../../APIsControll/apiControl2";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";

const UploadInvoiceModal = ({
  mode,
  close,
  managerId,
  orderId,
  totalAmount,
  invoiceStatus,
  orderStatus,
}) => {
  const { show } = useToast();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [files, setFiles] = useState({
    taxInvoice: null,
    ewayBill: null,
    detailedEwayBill: null,
    creditNote: null,
    debitNote: null, //! inactive
    cancelledTaxInvoice: null,
    cancelledEwayBill: null,
  });

  const uploadinvoicedata = async () => {
    if (newInvoice) {
      if (!files.taxInvoice) {
        show("Tax invoice is required!", "warning");
        return;
      }
      if (totalAmount >= 50000 && !files.ewayBill) {
        show(
          "Eway bill is required for orders greater than or equal to 50000!",
          "warning"
        );
        return;
      }
    }

    if (cancelledInvoice) {
      if (!files.cancelledTaxInvoice) {
        show("Cancelled tax invoice is required!", "warning");
        return;
      }
      if (totalAmount >= 50000 && !files.cancelledEwayBill) {
        show(
          "Cancelled eway bill is required for orders greater than or equal to 50000!",
          "warning"
        );
        return;
      }
    }

    if (orderReturnInvoice && !files.creditNote) {
      show("Cancelled tax invoice is required!", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("managerId", managerId);
    formData.append("orderId", orderId);
    formData.append("taxInvoice", files?.taxInvoice);
    formData.append("ewayBill", files?.ewayBill);
    formData.append("detailedEwayBill", files?.detailedEwayBill);
    formData.append("creditNote", files?.creditNote);
    formData.append("debitNote", files?.debitNote);
    formData.append("cancelledTaxInvoice", files?.cancelledTaxInvoice);
    formData.append("cancelledTaxInvoice", files?.cancelledTaxInvoice);

    try {
      setLoading(true);
      const res = await handleFileData(`invoice/uploadInvoice`, formData);
      if (res.status === "success") {
        setLoading(false);
        show(res.msg);
        navigate("/invoices/uploadedinvoice?orderId=" + orderId);
      } else if (res.status === "failed") {
        setLoading(false);
        show(res.msg, "error");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      show("An error occurred during file upload.", "error");
    }
  };

  const handleFileChange = (fieldName, file) => {
    setFiles((prev) => ({ ...prev, [fieldName]: file }));
  };

  const newInvoice =
    (orderStatus === "Packing In Progress" ||
      orderStatus === "Packed" ||
      orderStatus === "Dispatched" ||
      orderStatus === "Completed") &&
    (invoiceStatus === "Pending" || invoiceStatus === "Urgent");

  const cancelledInvoice =
    orderStatus === "Cancelled" &&
    (invoiceStatus === "Pending" ||
      invoiceStatus === "Urgent" ||
      invoiceStatus === "Cancelled");

  const orderReturnInvoice =
    orderStatus === "Order Return" &&
    (invoiceStatus === "Pending" || invoiceStatus === "Urgent");

  const alreadyUploaded = !newInvoice && !cancelledInvoice;

  // console.log("invoice status ", invoiceStatus);

  // console.log("order status ", orderStatus);

  // useEffect(() => {
  //   console.log("files ", files);
  // }, [files]);
  // useEffect(() => {
  //   console.log("New invoice ", newInvoice);
  // }, [newInvoice]);

  return (
    <div
      className={styles.upload_inv}
      style={mode ? { backgroundColor: "#232529" } : {}}
    >
      <div className={styles.head}>
        <p style={{ color: mode ? "#fff" : "#000" }}>Upload Invoice</p>
        <div onClick={close}>
          <CrossIcon color={mode ? "#FFFFFF" : "#000000"} />
        </div>
      </div>

      {newInvoice && (
        <>
          <div
            className={`${styles.upload_doc} ${
              mode ? styles.upload_doc_dark : {}
            }`}
          >
            <p>Tax Invoice</p>
            <PDFUpload
              fileType="application/pdf"
              mode={mode}
              pdfFile={files.taxInvoice}
              setPdfFile={(file) => handleFileChange("taxInvoice", file)}
              viewOnly={false}
            />
          </div>
          {totalAmount >= 50000 && (
            <>
              <div
                className={`${styles.upload_doc} ${
                  mode ? styles.upload_doc_dark : {}
                }`}
              >
                <p>Eway Bill</p>
                <PDFUpload
                  fileType="application/pdf"
                  mode={mode}
                  pdfFile={files.ewayBill}
                  setPdfFile={(file) => handleFileChange("ewayBill", file)}
                  viewOnly={false}
                />
              </div>

              <div
                className={`${styles.upload_doc} ${
                  mode ? styles.upload_doc_dark : {}
                }`}
              >
                <p>Detailed Eway Bill</p>
                <PDFUpload
                  fileType="application/pdf"
                  mode={mode}
                  pdfFile={files.detailedEwayBill}
                  setPdfFile={(file) =>
                    handleFileChange("detailedEwayBill", file)
                  }
                  viewOnly={false}
                />
              </div>
            </>
          )}
        </>
      )}

      {cancelledInvoice && (
        <>
          <div
            className={`${styles.upload_doc} ${
              mode ? styles.upload_doc_dark : {}
            }`}
          >
            <p>Cancelled Tax Invoice</p>
            <PDFUpload
              fileType="application/pdf"
              mode={mode}
              pdfFile={files.cancelledTaxInvoice}
              setPdfFile={(file) =>
                handleFileChange("cancelledTaxInvoice", file)
              }
              viewOnly={false}
            />
          </div>
          {totalAmount >= 50000 && (
            <>
              <div
                className={`${styles.upload_doc} ${
                  mode ? styles.upload_doc_dark : {}
                }`}
              >
                <p>Cancelled Eway Bill</p>
                <PDFUpload
                  fileType="application/pdf"
                  mode={mode}
                  pdfFile={files.cancelledEwayBill}
                  setPdfFile={(file) =>
                    handleFileChange("cancelledEwayBill", file)
                  }
                  viewOnly={false}
                />
              </div>
            </>
          )}
        </>
      )}

      {alreadyUploaded && (
        <>
          <NoDataFound
            icon={<CompletedImg  />}
            textTitle={"Invoice already uploaded!"}
          />
        </>
      )}

      <div className={styles.bottom_btns}>
        <Button
          buttonText={"Cancel"}
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonClick={close}
        />
        <Button
          buttonText={"Submit"}
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#FFFFFF"}
          buttonClick={uploadinvoicedata}
          loading={loading}
          disabled={loading || alreadyUploaded}
        />
      </div>
    </div>
  );
};

export default UploadInvoiceModal;
